import { z } from "zod";

/// DisplayType variants for a request parameter section.
/// A null/undefined displayType means the default - no styling.
export enum SectionDisplayTypeEnum {
    /// Box with a title (DisplayTitle) and an optional icon (ReactIcon).
    BOX_WITH_HEADER = 1,
    /// Box with a gray background.
    GRAY_BOX = 2,
    /// Box with a gray border.
    OUTLINED_BOX = 3,
}

export const SectionDisplayTypeEnumSchema = z.nativeEnum(SectionDisplayTypeEnum);
